import { useEffect, useState } from 'react';
import { useTheme, useLanguage } from '@/common/hooks';
import { NewTranslationsContext } from '@/common/translations';
import { T, UrlParams } from '@/common/enums';
import { getUrlParam } from '@/common/utils';
import { PrematchDataProvider } from '../../components';
import { PREMATCH_TRACKING_CONFIG, TrackingProvider } from '../../tracking';
import type { MainMenuOption } from '../../types';
import getInitialPrematchMainMenuTabFromUrl from '../../utils/getInitialPrematchMainMenuTabFromUrl';
import PrematchWidgetContent from './PrematchWidgetContent';

export default function PrematchWidget() {
  const [activeTab, setActiveTab] = useState<MainMenuOption>(getInitialPrematchMainMenuTabFromUrl);

  const { theme, toggleTheme } = useTheme();
  const themeURL = getUrlParam(UrlParams.THEME);
  const locale = useLanguage();

  useEffect(() => {
    if (themeURL) {
      toggleTheme(themeURL);
    }
  }, [themeURL, toggleTheme]);

  const themeClass = theme === T.DARK ? T.DARK : '';

  return (
    <TrackingProvider value={PREMATCH_TRACKING_CONFIG}>
      <PrematchDataProvider>
        <NewTranslationsContext.Provider value={{ locale }}>
          <div className={`h-full ${themeClass}`}>
            <PrematchWidgetContent activeTab={activeTab} onActiveTabChange={setActiveTab} />
          </div>
        </NewTranslationsContext.Provider>
      </PrematchDataProvider>
    </TrackingProvider>
  );
}
